export default "__VITE_ASSET__IfueT0Zo__"